import {selectCandidate} from 'store/candidate/candidateSlice';
import {selectBasketExams} from 'store/basket/basketSlice';
import {useAppSelector} from 'store/hooks';
import {
    useGetEligibilityCheckQuery,
} from 'store/candidate/candidateAPI';

export const useEligibilityCheck = () => {
    const basketItems = useAppSelector(selectBasketExams);
    const candidateDetails = useAppSelector(selectCandidate);
    const sessionId = basketItems[0]?.sessionId ?? 0;

    const {data, isFetching} = useGetEligibilityCheckQuery({
        sessionId: sessionId,
        candidateId: candidateDetails?.id ?? 0,
        examOptionIds: basketItems?.map(i => i.examOptionId),
        districtId: basketItems[0]?.districtId ?? 0,
    });

    return {
        proceedWithCashinRequired: data?.showWarning || false,
        messages: data?.messages,
        isLoading: isFetching
    };
};
